import "./FilterBars.scss";
import React, { useContext } from "react";
import Button from "core/buttons/button/Button";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import InfoContext from "pages/InfoContext";
import PropTypes from "prop-types";
import ClientsField from "./fields/ClientsField";
import BranchTagField from "./fields/BranchTagField";
import MissionTypeField from "./fields/MissionTypeField";

// Filters that assume a mission: they only apply to the CA/FAE table and the
// bar chart, both displayed right below. A consultant on the bench has neither
// a client nor a billing entity, so these filters are meaningless on the blocks
// driven by GlobalFilterBar.
const MissionFilterBar = ({ onSubmit }) => {
  const { chargedByFilter, storedChargedBy, setStoredChargedBy } =
    useContext(InfoContext);

  return (
    <div className="dashboard-filters-wrapper">
      <div className="dashboard-filters-title">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage
              id="dashboard_mission_filters"
              defaultMessage="Filtres sur les missions"
            />
          }
        />
      </div>
      <form onSubmit={onSubmit}>
        <div className="section-1">
          <div className="main-block single-row">
            <div className="line-2">
              <div className="cell-padding">
                <ClientsField />
              </div>
              <div className="cell-padding">
                <BranchTagField
                  name="charged_by_filter"
                  label={{
                    id: "billed_by_filter",
                    defaultMessage: "Affaires facturées par",
                  }}
                  selected={chargedByFilter}
                  stored={storedChargedBy}
                  setStored={setStoredChargedBy}
                  id="billed-by-filter"
                />
              </div>
              <div className="cell-padding">
                <MissionTypeField />
              </div>
            </div>
          </div>
        </div>
        <div className="buttons-container">
          <Button
            color="btn-medium gray-700"
            type="submit"
            id="dashboard_mission_btn"
          >
            <FormattedMessage id="dashboard_btn" defaultMessage="Rechercher" />
          </Button>
        </div>
      </form>
    </div>
  );
};

MissionFilterBar.propTypes = {
  onSubmit: PropTypes.func,
};

export default MissionFilterBar;
